import React, { useContext } from 'react';

import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

import { useHistory } from 'react-router';
import { ToolSelector } from 'src/components/UserSettings/AISettings/ToolSelector';
import { ROUTES } from 'src/constants/routes';
import { AgentContext } from 'src/contexts/AgentContext';

export const AISettings: React.FC = (props) => {
    const { endpoint, setEndpoint } = useContext(AgentContext);
    const history = useHistory();

    return (
        <Column width={'100%'}>
            <Row alignmentHorizontal={'justify'}>
                <Text type={'h400'}>AI Settings</Text>
                <Button type={'link'} onClick={() => history.push(ROUTES.AI.INDEX)} href={ROUTES.AI.INDEX}>
                    Return to AI Chat
                </Button>
            </Row>
            <Text type={'h300'}>Agent Endpoint</Text>
            <Row width={'60%'} widths={'fill'}>
                <Input size="small" width="240px" prefix={'Name'} value={endpoint} onChange={setEndpoint} />
            </Row>
            <ToolSelector />
        </Column>
    );
};
